module.exports = __webpack_public_path__ + "img/living-will.abb2915f.svg";